import axios from 'axios'
import store from '../pages/Integral/store'

let baseURL = process.env.VUE_APP_CURENV === "development" ? "/api" : '/api'

let token = ''

// let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiIwMDAwMDAiLCJ1c2VyX25hbWUiOiIxNTg1MjkyOTI5MSIsInJlYWxfbmFtZSI6IuWImOeQpiIsImF2YXRhciI6Imh0dHBzOi8vc3RhdGljLWxlZ2FjeS5kaW5ndGFsay5jb20vbWVkaWEvbEFEUERnUTlydmk5WHdmTW04eWJfMTU1XzE1NS5qcGciLCJhdXRob3JpdGllcyI6WyJkZXB0X2xlYWRlciIsImRpbmd0YWxrX2ludGVncmFsX2FkbWluIiwiY29tbW9uX2RhdGFfYWRtaW4iLCJkaW5ndGFsa19mZWlob3VodXBpbl9hZG1pbiIsInFhcl9hZG1pbiIsInNwZWNpYWxfZ3JvdXAiXSwiY2xpZW50X2lkIjoic2FiZXIiLCJyb2xlX25hbWUiOiJkZXB0X2xlYWRlcixkaW5ndGFsa19pbnRlZ3JhbF9hZG1pbixkaW5ndGFsa19mZWlob3VodXBpbl9hZG1pbixxYXJfYWRtaW4sY29tbW9uX2RhdGFfYWRtaW4sc3BlY2lhbF9ncm91cCIsImxpY2Vuc2UiOiJwb3dlcmVkIGJ5IGJsYWRleCIsInBvc3RfaWQiOiIxMTIzNTk4ODE3NzM4Njc1MjAxIiwidXNlcl9pZCI6IjE2MDExMzU3MDA0NjYwMTYyNTciLCJyb2xlX2lkIjoiMTYyNTU1MDYxODE3NDA3NDg4MSwxNjI1NTUwNjc3MDgzMDc0NTYxLDE2MjU1NTA3OTkwMzY2NTc2NjUsMTYyNTU1MDg0MjAxOTg4NTA1NywxNjI1NTUwODg1MzMwMjY4MTYxLDE2Mjg2NzEzNTg5ODE5MjY5MTMiLCJzY29wZSI6WyJhbGwiXSwibmlja19uYW1lIjoi5YiY55CmIiwib2F1dGhfaWQiOiIiLCJkZXRhaWwiOnsidHlwZSI6IndlYiIsImRlcHRJZExlYWRlciI6IjkyNjMxMzU1In0sImV4cCI6MTY4OTczMjU3OCwiZGVwdF9pZCI6IjkyNjMxMzU1IiwianRpIjoiN2YwMWJjYmItNTVjNS00NWI0LWJlNDItZmJmOGQ5MDQ0YzMwIiwiYWNjb3VudCI6IjE1ODUyOTI5MjkxIn0.nfs3bImN6p-G6wMY8r-p8V2dltuHvjNXNm8RwbDy-Kw'
// 创建 axios 实例
let http = axios.create({
    baseURL,
    timeout: 30000,
    retry: 3,
    retryDelay: 5000
})

// 添加请求拦截器
http.interceptors.request.use(config => {

    config.headers['Blade-Auth'] = 'bearer ' + (token==''?store.state.localToken || localStorage.getItem('mobile_token'):token)

    // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }

    // 请求发送前进行处理
    return config
}, error => {
    // 请求错误处理
    return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use(response => {
    let { data } = response
    // console.log('data >>> ', data)
    return data
}, err => {
    // console.log('err >>> ', err)
    return Promise.reject(err)
})

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function () {
    return http
}
